/**
 * output - ['a','b','c','d','e']
 * result - [['a','b'], ['c','d'], ['e']]
 */
export function splitIntoChunks<T extends any[]>(
  array: T,
  perChunk = 2,
): T[] {
  const result = array.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / perChunk);

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // start a new chunk
    }

    resultArray[chunkIndex].push(item);

    return resultArray;
  }, []);

  return result;
}
